<template>
    <div class="customer-stats">
        <div class="section-title__header">
            <div class="section-title__text">Clientes Frecuentes y Recompras</div>
            <div class="section-title__subtitle">Los clientes se identifican por su número de teléfono.</div>
        </div>
        <div class="customer-stats__grid" :style="{ gridTemplateColumns: user.role === 'admin' ? '1fr' : '1fr 1fr' }">
            <div class="customer-stats__left" :class="{ 'customer-stats__left--store': user.role === 'store' }">
                <StatCard icon="repeat" label="Tasa de Recompra" sublabel="Clientes que vuelven a comprar"
                    :value="repurchaseStats ? repurchaseStats.repurchaseRate : 0" suffix="%"
                    :detail="repurchaseStats ? `${repurchaseStats.recurringCount} de ${repurchaseStats.totalCustomers} clientes` : '0 de 0 clientes'"
                    color="#34C38F" :showProgress="true" />
                <StatCard icon="shopping_cart" label="Recompra Promedio"
                    sublabel="Pedidos promedio por cliente recurrente"
                    :value="repurchaseStats ? repurchaseStats.avgRepurchase : 0" suffix="" detail="pedidos"
                    color="#50A5F1" :showProgress="false" />
            </div>
            <div class="customer-stats__right">
                <TopCustomersRanking v-if="['store', 'admin'].includes(user.role)" />
                <TopStoresRanking v-if="['admin'].includes(user.role)" />
            </div>
        </div>
    </div>
</template>

<script>
import StatCard from './StatCard.vue';
import TopCustomersRanking from './TopCustomersRanking.vue';
import TopStoresRanking from './TopStoresRanking.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'CustomerStatsSection',
    components: {
        StatCard,
        TopCustomersRanking,
        TopStoresRanking
    },
    computed: {
        ...mapGetters(['repurchaseStats', 'user'])
    }
}
</script>

<style scoped>
.customer-stats__grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
}

.customer-stats__left {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.customer-stats__left--store {
    flex-direction: column;
}

.customer-stats__left>* {
    flex: 1;
}

.customer-stats__right {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
}

.customer-stats__right>* {
    flex: 1;
}

.section-title__header {
    margin-bottom: 1rem;
}

.section-title__text {
    font-size: 20px;
    font-weight: 600;
}

.section-title__subtitle {
    font-size: 0.85rem;
    color: #6c757d;
    margin-top: 0.2rem;
}

@media (max-width: 768px) {
    .customer-stats__grid {
        grid-template-columns: 1fr !important;
    }

    .customer-stats__left {
        flex-direction: column;
    }

    .customer-stats__right {
        flex-direction: column;
    }
}
</style>
